import MainButton from '../../../../components/buttons/mainButton/MainButton'
import { translations } from '../../../../configs/translations'
import { VehicleDamageDto } from '../../../../models/Vehicle'
import { useStore } from '../../../../store/store'
import './SearchUnavailableByDamage.css'

export interface SearchUnavailableByDamageProps {
	damage: VehicleDamageDto,
	onButtonClick: () => void
}

export const SearchUnavailableByDamage = ({ damage, onButtonClick }: SearchUnavailableByDamageProps) => {
	const language = useStore(state => state.language) as keyof typeof translations
	const t = translations[language]

	return (
		<div className="search-unavailable-by-damage">
			<div className="search-unavailable-by-damage-title-wrapper">
				<div className="search-unavailable-by-damage-title">{t.vehicle_got_damage_message}</div>
			</div>
			<MainButton
				text={t.pay_for_fix + damage?.price}
				buttonStyles={{ width: 300, height: 35 }}
				onClick={onButtonClick}
			/>
		</div>
	)
}